/* FENN: cabeçalho preso à tela + rolagem interna (11/09/2026, v2), par do fenn-rolagem.css.
 *  - tira o .header-section de dentro do .page-wrapper (o rolador) e o põe logo antes dele no <body>: assim o
 *    cabeçalho fica fora do quique da área de rolagem, como no layout offline (v42);
 *  - insere um espaço (.fenn-topo-espaco) no lugar que o cabeçalho ocupava, com a altura dele (--fenn-topo-altura);
 *  - expõe window.fennRolador() pros outros scripts (faixa de categorias, gaveta) saberem quem rola.
 * O cabeçalho NÃO é reposicionado por script (a versão anterior fazia isso nos primeiros 34 px e rasgava no iPhone).
 * Idempotente e religado por MutationObserver (o Horizon re-renderiza o cabeçalho depois da carga). */
(function () {
  function rolador() { return document.querySelector('.page-wrapper') || document.scrollingElement || document.documentElement; }
  window.fennRolador = rolador;

  var altAtual = '';
  function ligar() {
    var sec = document.querySelector('.header-section');
    var pw = document.querySelector('.page-wrapper');
    if (!sec || !pw) return;
    // espaço reservado no lugar original (dentro do #header-group, antes da barra de avisos)
    var esp = document.querySelector('.fenn-topo-espaco');
    if (!esp) {
      esp = document.createElement('div');
      esp.className = 'fenn-topo-espaco';
      esp.setAttribute('aria-hidden', 'true');
      sec.parentNode.insertBefore(esp, sec.nextSibling);
    }
    // cabeçalho fora do rolador
    if (sec.parentNode !== document.body) document.body.insertBefore(sec, pw);
    medir();
  }
  function medir() {
    var cab = document.getElementById('header-component');
    if (!cab) return;
    var alt = Math.round(cab.offsetHeight) + 'px';
    if (alt !== altAtual) { altAtual = alt; document.documentElement.style.setProperty('--fenn-topo-altura', alt); }
  }

  function iniciar() {
    ligar();
    window.addEventListener('resize', medir);
    window.addEventListener('load', medir);
    setTimeout(medir, 300);
    setTimeout(medir, 1200);
    new MutationObserver(function () {
      var sec = document.querySelector('.header-section');
      if (!document.querySelector('.fenn-topo-espaco') || (sec && sec.parentNode !== document.body)) ligar();
    }).observe(document.documentElement, { childList: true, subtree: true });
    document.addEventListener('shopify:section:load', ligar);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar); else iniciar();
})();
